// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.skeleton__jqorr {
  display: block;
  background-color: rgba(242, 242, 242, 0.13);
}
.skeleton--fit-content__eRgMk {
  max-width: fit-content;
  height: auto;
}
.skeleton--circle__UUKPH {
  border-radius: 50%;
}
.skeleton--text__rS6jb {
  height: auto;
  border-radius: 4px;
  transform-origin: 0 60%;
}
.skeleton--text__rS6jb:before {
  content: " ";
}
.skeleton--pulse__s3XZM {
  animation: skeleton-pulse__gcmpY 1.5s ease-in-out 0.5s infinite;
}
.skeleton--wave__HgOLX {
  position: relative;
  overflow: hidden;
}
.skeleton--wave__HgOLX:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  animation: skeleton-wave__k7oDo 1.5s linear 0.5s infinite;
  background-image: linear-gradient(90deg, transparent, rgba(242, 242, 242, 0.05) 20%, rgba(242, 242, 242, 0.1) 60%, transparent);
  transform: translateX(-100%);
}

@keyframes skeleton-pulse__gcmpY {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
@keyframes skeleton-wave__k7oDo {
  50%, 100% {
    transform: translateX(100%);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/skeleton/skeleton.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,cAAA;EACA,2CAAA;AADF;AAGE;EACE,sBAAA;EACA,YAAA;AADJ;AAIE;EACE,kBAAA;AAFJ;AAKE;EACE,YAAA;EAEA,kBAAA;EACA,uBAAA;AAJJ;AAMI;EACE,YAAA;AAJN;AAQE;EACE,+DAAA;AANJ;AASE;EACE,kBAAA;EACA,gBAAA;AAPJ;AASI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yDAAA;EACA,+HAAA;EAOA,4BAAA;AAbN;;AAqBA;EACE;IACE,UAAA;EAlBF;EAoBA;IACE,YAAA;EAlBF;EAoBA;IACE,UAAA;EAlBF;AACF;AAqBA;EACE;IAEE,2BAAA;EApBF;AACF","sourcesContent":["// ===============================\n// Skeleton\n// ===============================\n.skeleton {\n  display: block;\n  background-color: rgba(242, 242, 242, 0.13);\n\n  &--fit-content {\n    max-width: fit-content;\n    height: auto;\n  }\n\n  &--circle {\n    border-radius: 50%;\n  }\n\n  &--text {\n    height: auto;\n    //transform: scale(1, 0.6);\n    border-radius: 4px;\n    transform-origin: 0 60%;\n\n    &:before {\n      content: '\\00a0';\n    }\n  }\n\n  &--pulse {\n    animation: skeleton-pulse 1.5s ease-in-out 0.5s infinite;\n  }\n\n  &--wave {\n    position: relative;\n    overflow: hidden;\n\n    &:after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      animation: skeleton-wave 1.5s linear 0.5s infinite;\n      background-image: linear-gradient(\n        90deg,\n        transparent,\n        rgba(242, 242, 242, 0.05) 20%,\n        rgba(242, 242, 242, 0.1) 60%,\n        transparent\n      );\n      transform: translateX(-100%);\n    }\n  }\n}\n\n// ===============================\n// Animations\n// ===============================\n@keyframes skeleton-pulse {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes skeleton-wave {\n  50%,\n  100% {\n    transform: translateX(100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeleton": `skeleton__jqorr`,
	"skeleton--fit-content": `skeleton--fit-content__eRgMk`,
	"skeleton--circle": `skeleton--circle__UUKPH`,
	"skeleton--text": `skeleton--text__rS6jb`,
	"skeleton--pulse": `skeleton--pulse__s3XZM`,
	"skeleton-pulse": `skeleton-pulse__gcmpY`,
	"skeleton--wave": `skeleton--wave__HgOLX`,
	"skeleton-wave": `skeleton-wave__k7oDo`
};
export default ___CSS_LOADER_EXPORT___;
